module.exports = __webpack_public_path__ + "static/media/discover.svg.64d0c287.png";